const onlyNumbers = /\D/g;
const onlyLetters = /[^a-zA-Z]+/g;
const noSpecialCharacters = /[^\w\s]/gi;
const noSpaces = /^\S*$/;

export {
    onlyNumbers,
    onlyLetters,
    noSpecialCharacters,
    noSpaces
};
